import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SendIcon, CheckCircle2Icon } from 'lucide-react';
import { SITE } from '../constants/site';
export function ScheduleFormSection() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    address: '',
    service: '',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      id,
      value,
      name,
      type
    } = e.target;
    if (type === 'radio') {
      const radio = e.target as HTMLInputElement;
      setFormData(prev => ({
        ...prev,
        service: radio.checked ? value : ''
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [id || name]: value
      }));
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const textBody = `New Service Request:
Name: ${formData.firstName} ${formData.lastName}
Phone: ${formData.phone}
Address: ${formData.address}
Service: ${formData.service}
Details: ${formData.message}`;
    const encodedBody = encodeURIComponent(textBody);
    const smsUrl = `${SITE.smsHref}${SITE.smsHref.includes('?') ? '&' : '?'}body=${encodedBody}`;
    window.location.href = smsUrl;
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({
        firstName: '',
        lastName: '',
        phone: '',
        address: '',
        service: '',
        message: ''
      });
    }, 5000);
  };
  return <section id="schedule" className="w-full bg-slate-50 py-16 sm:py-24" data-id="element-316" data-mp="1ni0dmn6d72og">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-id="element-317" data-mp="1ni8rahabac0p">
        <div className="text-center" data-id="element-318" data-mp="1rij86ozn6muc">
          <h2 className="font-display text-3xl font-extrabold text-slate-900 sm:text-4xl" data-id="element-319" data-mp="1rhhjvitm83uo">
            Ready to fix your system?
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-320" data-mp="zsy09rirjvzr">
            Fill out the form below and our team will quickly reach out to confirm your appointment.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-10 rounded-3xl border border-slate-200 bg-white p-6 shadow-xl sm:p-10" data-id="element-321" data-mp="274nlyn96q8td">
          {isSubmitted ? <div className="flex flex-col items-center justify-center py-12 text-center" data-id="element-322" data-mp="2bvdprw1yq3ly">
              <div className="flex h-20 w-20 items-center justify-center rounded-full bg-nfgreen/10 text-nfgreen" data-id="element-323" data-mp="1o5jdbflk2h28">
                <CheckCircle2Icon className="h-10 w-10" data-id="element-324" data-mp="1j801emcbygdg" />
              </div>
              <h3 className="mt-6 font-display text-2xl font-bold text-slate-900" data-id="element-325" data-mp="1x6hhpyzwoqlc">
                Request Prepared
              </h3>
              <p className="mt-2 text-slate-600" data-id="element-326" data-mp="1t4cv3k7vku87">
                Your messaging app should now be open with your details. Please send the message to complete your request.
              </p>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-327" data-mp="34k1ddya6p52o">
              <div className="grid gap-6 sm:grid-cols-2" data-id="element-328" data-mp="3c2sj49tp7n9s">
                <div data-id="element-329" data-mp="3h2x4oe9gr86v">
                  <label htmlFor="section-firstName" className="block text-sm font-bold text-slate-700" data-id="element-330" data-mp="3h36vg42c1jdm">
                    First name <span className="text-red-500" data-id="element-331" data-mp="326phr66o7snw">*</span>
                  </label>
                  <input type="text" id="section-firstName" name="firstName" value={formData.firstName} onChange={handleChange} required className="mt-2 block w-full rounded-xl border border-slate-300 px-4 py-3 text-slate-900 placeholder-slate-400 focus:border-nfblue focus:outline-none focus:ring-2 focus:ring-nfblue/20" placeholder="First" data-id="element-332" data-mp="373xtop1870gp" />
                </div>
                <div data-id="element-333" data-mp="hmgysvezsrc4">
                  <label htmlFor="section-lastName" className="block text-sm font-bold text-slate-700" data-id="element-334" data-mp="mei602xazrva">
                    Last name <span className="text-red-500" data-id="element-335" data-mp="2uvb7tkcngf59">*</span>
                  </label>
                  <input type="text" id="section-lastName" name="lastName" value={formData.lastName} onChange={handleChange} required className="mt-2 block w-full rounded-xl border border-slate-300 px-4 py-3 text-slate-900 placeholder-slate-400 focus:border-nfblue focus:outline-none focus:ring-2 focus:ring-nfblue/20" placeholder="Last" data-id="element-336" data-mp="2pwhp9dii9xy8" />
                </div>
              </div>

              <div className="grid gap-6 sm:grid-cols-2" data-id="element-337" data-mp="33uofq8l4kvnv">
                <div data-id="element-338" data-mp="2yxpn5uh40wrs">
                  <label htmlFor="section-phone" className="block text-sm font-bold text-slate-700" data-id="element-339" data-mp="2yw4vccm6jrxm">
                    Your Phone number <span className="text-red-500" data-id="element-340" data-mp="8qswk00ykw6">*</span>
                  </label>
                  <input type="tel" id="section-phone" name="phone" value={formData.phone} onChange={handleChange} required className="mt-2 block w-full rounded-xl border border-slate-300 px-4 py-3 text-slate-900 placeholder-slate-400 focus:border-nfblue focus:outline-none focus:ring-2 focus:ring-nfblue/20" placeholder="(555) 555-5555" data-id="element-341" data-mp="3rl1zlbtk3o7d" />
                </div>
                <div data-id="element-342" data-mp="mm4yez2ck1yf">
                  <label htmlFor="section-address" className="block text-sm font-bold text-slate-700" data-id="element-343" data-mp="qpb3429t9l2s">
                    Service Address <span className="text-red-500" data-id="element-344" data-mp="vfztfe9r8c0c">*</span>
                  </label>
                  <input type="text" id="section-address" name="address" value={formData.address} onChange={handleChange} required className="mt-2 block w-full rounded-xl border border-slate-300 px-4 py-3 text-slate-900 placeholder-slate-400 focus:border-nfblue focus:outline-none focus:ring-2 focus:ring-nfblue/20" placeholder="1234 Main St, City, TX Zip" data-id="element-345" data-mp="10fvylgu6u9hh" />
                </div>
              </div>

              <div data-id="element-346" data-mp="pohksz974gwh">
                <label className="block text-sm font-bold text-slate-700" data-id="element-347" data-mp="pny2hhfmvqhx">
                  Service Requested <span className="text-red-500" data-id="element-348" data-mp="13fmfdmxpiizy">*</span>
                </label>
                <div className="mt-3 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-349" data-mp="13hp9oj5w6yah">
                  {['Irrigation Repair', 'New Installation', 'Christmas Lights', 'Drainage / Other'].map(service => <label key={`section-${service}`} className="flex cursor-pointer items-center gap-3 rounded-xl border border-slate-200 p-3 transition-colors hover:bg-slate-50 has-[:checked]:border-nfblue has-[:checked]:bg-nfblue/5" data-id="element-350" data-mp="18eza0tutkud3">
                      <input type="radio" name="service" value={service} checked={formData.service === service} onChange={handleChange} required className="h-4 w-4 rounded-full border-slate-300 text-nfblue focus:ring-nfblue" data-id="element-351" data-mp="1pob8ic7btmv7" />
                      <span className="text-sm font-medium text-slate-700" data-id="element-352" data-mp="16xacnx1i67fv">{service}</span>
                    </label>)}
                </div>
              </div>

              <div data-id="element-353" data-mp="wzm7sea6njjz">
                <label htmlFor="section-message" className="block text-sm font-bold text-slate-700" data-id="element-354" data-mp="x05mzn8g7tub">
                  Additional Information <span className="text-red-500" data-id="element-355" data-mp="11zia8938f2xf">*</span>
                </label>
                <p className="mt-1 text-xs text-slate-500" data-id="element-356" data-mp="2rddq026kvbr1">
                  Please provide any details about the issue and dates/times that work best for you.
                </p>
                <textarea id="section-message" name="message" value={formData.message} onChange={handleChange} required rows={3} className="mt-3 block w-full resize-none rounded-xl border border-slate-300 px-4 py-3 text-slate-900 placeholder-slate-400 focus:border-nfblue focus:outline-none focus:ring-2 focus:ring-nfblue/20" placeholder="Type your message here..." data-id="element-357" data-mp="1j5nbqf3m9lji" />
              </div>

              <div className="pt-2" data-id="element-358" data-mp="vereh2ge5y4v">
                <button type="submit" className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-nfblue px-8 py-4 text-base font-bold text-white shadow-lg shadow-nfblue/30 transition-transform hover:scale-[1.02] hover:bg-nfblue-dark focus:outline-none focus:ring-2 focus:ring-nfblue focus:ring-offset-2" data-id="element-359" data-mp="repmxm4del3b">
                  <SendIcon className="h-5 w-5" data-id="element-360" data-mp="2grkodvvbewnj" />
                  Send via Text Message
                </button>
                <p className="mt-3 text-center text-xs text-slate-500" data-id="element-361" data-mp="2obc0n4kzo7th">
                  This will open your phone's messaging app to send the details directly to us.
                </p>
              </div>
            </form>}
        </motion.div>
      </div>
    </section>;
}